import { MockService, MockServiceEndpoint, SV, TRANSACTIONAL } from '../../types/rest/mockServiceTypes';
import { isPortDisplayable, isCellEditable } from '../../utils/mockServiceUtils';
import InputGroup from 'react-bootstrap/InputGroup';
import styles from '../../views/MockServices/Tabs/MockServices/MockServicesListBlazeTable.module.css';
import Dropdown from 'react-bootstrap/Dropdown';
import BlazeToggle from '../ui/toggle/BlazeToggle';
import { DEFAULT_POPPER_CONFIG } from '../../constants/ui-constants';
import MockPreferredPortCell from '../../views/MockServices/Tabs/MockServices/Cells/MockPreferredPortCell';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import CopyToClipboardButton from '../buttons/CopyToClipboardButton';
import BzmIcon from '../icons/BzmIcon';
import React from 'react';
import i18n from 'i18next';
import _ from 'lodash';
import EndpointValue from './EndpointValue';

interface EndpointProps {
  mockService: MockService;
  isRowEnabled: boolean;
  isPrivateCloudReadOnly: boolean;
  endpointPreferenceChanged: (rowData: any, newPreference: string) => void;
  toggleExpandDetail: (id: number | null) => void; //async
  preferredPortChanged: (rowData: any, preferredPort: string) => void;
  displayPortField?: boolean;
  /** Min width is applied if port input is shown */
  minWidth?: number;
  type: 'group' | 'mockService';
}

const Endpoint = (props: EndpointProps) => {
  const mockService = props.mockService;
  const isPortEditFieldDisplayed =
    mockService.status !== 'RUNNING' &&
    (props.displayPortField === true || isPortDisplayable(mockService.harborId, mockService.shipId));
  const isRowEnabled = isPortEditFieldDisplayed ? isCellEditable(mockService) : props.isRowEnabled;
  const preferredPort = _.get(mockService.metadata, 'preferredPort', '');

  if (isRowEnabled) {
    if (!mockService.type || mockService.type === TRANSACTIONAL) {
      return (
        <form
          id={`formIdmockPreferredPort` + mockService.id}
          style={{ minWidth: isPortEditFieldDisplayed ? props.minWidth : undefined }}
        >
          <InputGroup>
            <span>
              <InputGroup.Append style={{ marginRight: '-1px' }}>
                <InputGroup.Text
                  className={styles.protocolAndPortLabelRadius}
                  title={i18n.t('mockServices:mockServicesTable.protocol')}
                >
                  {i18n.t('mockServices:mockServicesTable.protocol')}
                </InputGroup.Text>
              </InputGroup.Append>
            </span>
            <div className="dropdown-menu-limited" style={{ width: '75px' }}>
              <Dropdown>
                <Dropdown.Toggle
                  disabled={props.isPrivateCloudReadOnly}
                  id={`mockServiceEndpointSelected` + mockService.id}
                  style={{ borderTopLeftRadius: '0', borderBottomLeftRadius: '0' }}
                  as={BlazeToggle}
                >
                  {mockService.endpointPreference}
                </Dropdown.Toggle>
                <Dropdown.Menu popperConfig={DEFAULT_POPPER_CONFIG} className={styles.endpointPicker}>
                  <Dropdown.Item
                    onClick={() => props.endpointPreferenceChanged(mockService, 'HTTPS')}
                    key="HTTPS"
                    dangerouslySetInnerHTML={{ __html: 'HTTPS' }}
                  />
                  <Dropdown.Item
                    onClick={() => props.endpointPreferenceChanged(mockService, 'HTTP')}
                    key="HTTP"
                    dangerouslySetInnerHTML={{ __html: 'HTTP' }}
                  />
                </Dropdown.Menu>
              </Dropdown>
            </div>
            {isPortEditFieldDisplayed && (
              <>
                <div>
                  <InputGroup.Append style={{ marginRight: '-1px', paddingLeft: '10px' }}>
                    <InputGroup.Text
                      className={styles.protocolAndPortLabelRadius}
                      title={i18n.t('mockServices:mockServicesTable.port')}
                    >
                      {i18n.t('mockServices:mockServicesTable.port')}
                    </InputGroup.Text>
                  </InputGroup.Append>
                </div>
                <MockPreferredPortCell
                  id={`mockPreferredPort` + mockService.id}
                  isEditable={isRowEnabled}
                  mockService={mockService}
                  preferredPort={preferredPort}
                  onChange={props.preferredPortChanged}
                  disabled={props.isPrivateCloudReadOnly || (!mockService.httpRunnerEnabled && props.type !== 'group')}
                  className={'col-md-5'}
                  isMandatory={props.displayPortField}
                  type={props.type}
                  title={
                    !mockService.httpRunnerEnabled &&
                    props.type !== 'group' &&
                    'HTTP Runner has to be enabled to edit port'
                  }
                />
              </>
            )}
          </InputGroup>
        </form>
      );
    } else {
      return <div id={`mockServiceEndpointValue` + mockService.id}>-</div>;
    }
  }

  if (mockService.metaData.isDeployed || mockService.metaData.isStopped) {
    return (
      <div id={`mockServiceEndpointValue` + mockService.id}>
        <EndpointValue endpoints={mockService.endpoints} />
      </div>
    );
  }

  return <div>-</div>;
};

export default Endpoint;
